/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierInvoiceApprovalType {
  Approved = "Approved",
  NotApprovedTooExpensive = "NotApprovedTooExpensive",
  NotApprovedInvalidCurrency = "NotApprovedInvalidCurrency",
  Duplicate = "Duplicate",
  Zero = "Zero",
  NoInvoices = "NoInvoices",
  TaxMismatch = "TaxMismatch",
  NotApprovedCancelled = "NotApprovedCancelled",
  NotApprovedChallengeAllInvoices = "NotApprovedChallengeAllInvoices",
  NotApprovedWrongCarrier = "NotApprovedWrongCarrier",
}

export function instanceOfCarrierInvoiceApprovalType(value: any): boolean {
  for (const key in CarrierInvoiceApprovalType) {
    if (Object.prototype.hasOwnProperty.call(CarrierInvoiceApprovalType, key)) {
      if (
        CarrierInvoiceApprovalType[
          key as keyof typeof CarrierInvoiceApprovalType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierInvoiceApprovalTypeFromJSON(
  json: any,
): CarrierInvoiceApprovalType {
  return CarrierInvoiceApprovalTypeFromJSONTyped(json, false);
}

export function CarrierInvoiceApprovalTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierInvoiceApprovalType {
  return json as CarrierInvoiceApprovalType;
}

export function CarrierInvoiceApprovalTypeToJSON(
  value?: CarrierInvoiceApprovalType | null,
): any {
  return value as any;
}

export function CarrierInvoiceApprovalTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierInvoiceApprovalType {
  return value as CarrierInvoiceApprovalType;
}
